(function () {
  if (window.mtQuickViewReady) return;
  window.mtQuickViewReady = true;

  var LOCALE = 'en-NZ';
  var cfg = null, modal, panelBody, lastFocus;

  function config() {
    if (cfg) return cfg;
    var host = document.querySelector('[data-mt-related-bundles]');
    cfg = {
      cartAdd: (host && host.getAttribute('data-cart-add')) || '/cart/add',
      cartUrl: (host && host.getAttribute('data-cart')) || '/cart',
      currency: (host && host.getAttribute('data-currency')) || 'NZD'
    };
    return cfg;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency: config().currency
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function build() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'mt-qv';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="mt-qv__backdrop" data-mt-qv-close></div>' +
      '<div class="mt-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
      '<button class="mt-qv__close" type="button" data-mt-qv-close aria-label="Close">&#215;</button>' +
      '<div class="mt-qv__body"></div></div>';
    document.body.appendChild(modal);
    panelBody = modal.querySelector('.mt-qv__body');

    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-mt-qv-close')) close();
    });
    panelBody.addEventListener('click', function (e) {
      var add = e.target.closest('[data-mt-qv-add]');
      if (!add) return;
      var sel = panelBody.querySelector('[data-mt-qv-variant]');
      addToCart(sel ? sel.value : add.getAttribute('data-first'), add);
    });
  }

  function open() {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.mt-qv__close').focus();
  }

  function close() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function render(p) {
    var img = p.featured_image || p.images[0] || '';
    var opts = '';

    if (p.variants.length > 1) {
      opts = '<select class="mt-qv__select" data-mt-qv-variant>';
      p.variants.forEach(function (v) {
        opts += '<option value="' + v.id + '">' + v.title + ' &#8211; ' + money(v.price) + '</option>';
      });
      opts += '</select>';
    }

    var was = '';
    if (p.compare_at_price > p.price) {
      was = ' <s class="mt-qv__was">' + money(p.compare_at_price) + '</s>';
    }

    panelBody.innerHTML =
      (img ? '<img class="mt-qv__img" src="' + img + '" alt="">' : '') +
      '<div class="mt-qv__name">' + p.title + '</div>' +
      '<div class="mt-qv__price">' + money(p.price) + was + '</div>' +
      opts +
      '<button class="mt-qv__add" type="button" data-mt-qv-add data-first="' +
        p.variants[0].id + '">Add to cart</button>' +
      '<div class="mt-qv__err" hidden></div>' +
      '<a class="mt-qv__link" href="/products/' + p.handle + '">See full details</a>';
  }

  function addToCart(id, button) {
    var err = panelBody.querySelector('.mt-qv__err');
    err.hidden = true;
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch(config().cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || 'Could not add to cart');
        close();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer, .cart-drawer, #cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          window.location.href = config().cartUrl;
        }
      })
      .catch(function (e) {
        err.textContent = e.message;
        err.hidden = false;
        button.disabled = false;
        button.textContent = 'Add to cart';
      });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) close();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mt-qv]');
    if (!trigger) return;
    e.preventDefault();

    var handle = trigger.getAttribute('data-mt-qv');
    build();
    lastFocus = trigger;
    panelBody.innerHTML = '<p class="mt-qv__loading">Loading...</p>';
    open();

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('not found');
        return res.json();
      })
      .then(render)
      .catch(function () {
        window.location.href = '/products/' + handle;
      });
  });
})();